import Field from "controls/Field";
import FormDialog from "controls/FormDialog";
import Message from "controls/Message";
import { useActionFragment } from "hooks/useAction";
import NumberInput from "inputs/NumberInput";
import { Plus } from "mdi-material-ui";
import React from "react";
import { useState } from "react";
import ReadminObjectInput from "readmin_pages/shared/ReadminObjectInput";

import GameCutForm from "./GameCutForm";

AddGameDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Manually Add Game",
  };
};

export default function AddGameDialog({
  leagueId = null,
  courtId = null,
  homeId = null,
  awayId = null,
  playedAt = null,
  completedAt = null,
  onSubmit,
  onClose,
}) {
  const [league, leagueSet] = useState(
    leagueId && {
      id: leagueId,
      __typename: "League",
    },
  );
  const [recordingsAvailable, recordingsAvailableSet] = useState(false);
  const addGame = useActionFragment("addGame", "game { id }");

  return (
    <FormDialog
      onClose={onClose}
      header="Add game"
      disabled={!recordingsAvailable}
      onSubmit={async (formData) => {
        const result = await addGame({
          input: {
            ...formData,
          },
        });
        await onSubmit?.(result.addGame.game);
      }}
    >
      <Message
        type="info"
        content={
          <>
            Use this tool to add a game that was not scored using any scoring app. This will make the game video
            available to existing team members but without any stats.
          </>
        }
      />
      <GameCutForm
        game={{
          playedAt,
          completedAt,
          court: courtId && { id: courtId },
        }}
        onRecordingsAvailableChange={recordingsAvailableSet}
      />
      <Field
        name="league"
        label="League"
        input={<ReadminObjectInput optionsTypename="League" />}
        required
        value={league}
        onChange={leagueSet}
      />
      <Field
        name="home"
        label="Home Team"
        disabled={!league}
        input={<ReadminObjectInput optionsTypename="Team" optionsFilters={{ in_league_id: league?.id }} />}
        required
        defaultValue={homeId && { id: homeId, __typename: "Team" }}
      />
      <Field
        name="away"
        label="Away Team"
        disabled={!league}
        input={<ReadminObjectInput optionsTypename="Team" optionsFilters={{ in_league_id: league?.id }} />}
        required
        defaultValue={awayId && { id: awayId, __typename: "Team" }}
      />
      <Field name="homeScore" label="Home Team Score" required input={<NumberInput min={0} />} />
      <Field name="awayScore" label="Away Team Score" required input={<NumberInput min={0} />} />
    </FormDialog>
  );
}
